import React, { useEffect, useState } from 'react';
import './SuccessOverlay.css';

const SuccessOverlay = ({ active, title, subtitle, onComplete, duration = 4000, type }) => {
  const [isVisible, setIsVisible] = useState(active);

  useEffect(() => {
    if (active) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onComplete) onComplete();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [active, duration, onComplete]);

  if (!active) return null;

  return (
    <div className={`success-overlay-container ${isVisible ? 'active' : 'closing'} success-type-${type || 'default'}`}>
      <div className="success-glass-backdrop"></div>
      
      <div className="success-card">
        <div className="success-icon-wrap">
          <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
        
        <div className="success-content">
          <h2>{title || 'Success!'}</h2>
          <p>{subtitle || 'Your action was completed successfully.'}</p>
        </div>

        <div className="success-particles">
          {[...Array(20)].map((_, i) => (
            <div key={i} className={`particle particle-${i}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessOverlay;
